import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from '../services/auth.service';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AddCsrfTokenInterceptor implements HttpInterceptor {
    constructor(private readonly cookieService: CookieService, private readonly authService: AuthService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const hasCsrfToken = this.cookieService.check('mdr_csrf_token');

        if (!hasCsrfToken) {
            return next.handle(request);
        }

        if (request.headers.has(AuthService.CsrfProtectionHeader)) {
            return next.handle(request);
        }

        if (this.authService.shouldRefreshJwtTokens()) {
            return this.authService.refreshTokens().pipe(
                catchError((err) => {
                    console.error(`Failed to refresh tokens ${err}`);
                    return of();
                }),
                switchMap(() => {
                    return this.addCsrfTokenInRequest(request, next);
                }),
            );
        }

        return this.addCsrfTokenInRequest(request, next);
    }

    private addCsrfTokenInRequest(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const csrfToken = this.cookieService.get('mdr_csrf_token');

        return next.handle(
            request.clone({
                headers: request.headers.set(AuthService.CsrfProtectionHeader, csrfToken),
            }),
        );
    }
}
